      function initBraSizeDropdown() {
    const dtSelector = '#bra_size dt';
    const ddSelector = '#bra_size dd';

    $(dtSelector).off('click').on('click', function (e) {
      e.stopPropagation();

      const $clickedDt = $(this);
      const $clickedDd = $clickedDt.next('dd');
      const isActive = $clickedDt.hasClass('highlight');

      // 一度全部閉じる
      $(ddSelector).slideUp();
      $(dtSelector).removeClass('highlight');

      if (!isActive) {
        $clickedDd.slideDown();
        $clickedDt.addClass('highlight');
      }
    });

    $(document).off('click.brasize').on('click.brasize', function (e) {
      if (!$(e.target).closest('#bra_size').length) {
        $(ddSelector).slideUp();
        $(dtSelector).removeClass('highlight');
      }
    });
  }

  // ページ読み込み時
  $(document).ready(function () {
    initBraSizeDropdown();
  });

  // Shopifyセクション再読み込み時（Shopifyが使ってるイベント）
  document.addEventListener('shopify:section:load', function () {
    initBraSizeDropdown();
  });